export interface BusinessRecordWorkspaceTab { slug: string; label: string }

const auBusinessRecordTabs: BusinessRecordWorkspaceTab[] = [
  ['identity', 'Identity'], ['workplaces', 'Workplaces'], ['payrolls', 'Payrolls'],
  ['public-holidays', 'Public holidays'], ['stp', 'STP'], ['payroll-tax', 'Payroll tax'],
  ['workers-compensation', 'Workers compensation'], ['employer-banking', 'Employer banking'],
  ['compliance-rules', 'Compliance rules'], ['pay-advice', 'Pay advice'],
].map(([slug, label]) => ({ slug, label }));

const publicHolidayBusinessRecordTabs: BusinessRecordWorkspaceTab[] = [
  ['identity', 'Identity'], ['public-holidays', 'Public holidays'],
].map(([slug, label]) => ({ slug, label }));

// Region Profiles register their applicable workspace here. The screen consumes
// this contract and contains no region-specific branching.
const regionProfiles: Record<string, BusinessRecordWorkspaceTab[]> = {
  AU: auBusinessRecordTabs,
  NZ: publicHolidayBusinessRecordTabs,
  UK: publicHolidayBusinessRecordTabs,
  US: publicHolidayBusinessRecordTabs,
};

export const getBusinessRecordWorkspaceTabs = (regionCode: string): BusinessRecordWorkspaceTab[] =>
  regionProfiles[regionCode.toUpperCase() === 'GB' ? 'UK' : regionCode.toUpperCase()] ?? [];
